(() => {
  if (window.__bmgAccountControllerReady) return;
  window.__bmgAccountControllerReady = true;

  const DEVICE_STORAGE_KEYS = [
    'bmgBuddyTrackerPrototypeV1',
    'bmgAudioPlayerPrototypeV1',
    'bmgAccessModePreviewV1',
    'bmgBuddyInvitePreviewV1'
  ];

  function clearBmgDeviceData() {
    [localStorage, sessionStorage].forEach((storage) => {
      try {
        DEVICE_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
        Object.keys(storage).filter((key) => key.toLowerCase().startsWith('bmg')).forEach((key) => storage.removeItem(key));
      } catch (error) { /* Storage can be unavailable in privacy modes. */ }
    });
  }

  const account = document.querySelector('[data-bmg-account]');
  const tracker = document.querySelector('[data-bmg-tracker]');
  const invite = document.querySelector('[data-bmg-buddy-invite]');
  const params = new URLSearchParams(window.location.search);
  const requestedAccess = params.get('access') || 'free';
  const access = account ? 'free' : requestedAccess;
  const status = params.get('status') || '';

  const accessCopy = {
    free: {
      kicker: 'Create your free account',
      title: 'Start with one complete practice.',
      lede: 'Unlock the complete Baseline 30 practice, saved playback, a simple practice Log, private Awareness Notes, and the Program Guide online.',
      badge: 'Free access preview'
    },
    individual: {
      kicker: 'Activate Individual access',
      title: 'Connect your permanent seat.',
      lede: 'Use the email from checkout. After verification, continue to My BREATHmg and the complete program.',
      badge: 'Individual access preview'
    },
    buddies: {
      kicker: 'Activate Breath Buddies',
      title: 'Connect your seat and your circle.',
      lede: 'Use the purchaser email to open My BREATHmg and prepare the three invitations included with the four-seat purchase.',
      badge: 'Breath Buddies preview'
    },
    military: {
      kicker: 'Activate military access',
      title: 'Connect your complete seat.',
      lede: 'Use the email from your approved $0 checkout to open My BREATHmg and the complete program.',
      badge: 'Military access preview'
    },
    scholarship: {
      kicker: 'Activate scholarship access',
      title: 'Connect your complete seat.',
      lede: 'Use the email from your $0 checkout to open My BREATHmg and the complete program.',
      badge: 'Access Scholarship'
    },
    nonprofit: {
      kicker: 'Organization access',
      title: 'Continue with your approved email.',
      lede: 'Use the work email connected to the approved organization request. Seat access is configured separately for each organization.',
      badge: 'Organization access preview'
    },
    invite: {
      kicker: 'Breath Buddies invitation',
      title: 'Your circle is waiting.',
      lede: 'Continue with the email that received the invitation. Each Buddy has a separate account, private history, and private Awareness Notes.',
      badge: 'Invited Buddy preview'
    }
  };

  const statusCopy = {
    connected: ['Account connected', 'Your Shopify account is connected. Continue to My BREATHmg or open the complete program.'],
    pending: ['Access is being prepared', 'Your account exists, but program access has not been attached yet. Check the access email or contact support.'],
    'no-access': ['No program access found', 'This email is not connected to BREATHmg access yet. Try the purchase or application email, or contact support.'],
    'wrong-email': ['Check the email used', 'Sign out and continue with the email used at checkout, on the access form, or in the Buddy invitation.'],
    expired: ['Invitation expired', 'This Buddy invitation can no longer be used. Ask the purchaser to send a new invitation.'],
    full: ['The circle is full', 'All four Breath Buddies seats are currently connected. Ask the purchaser to review the circle.']
  };

  const current = accessCopy[access] || accessCopy.free;

  function safelyStore(key, value) {
    try { localStorage.setItem(key, value); } catch (error) { /* Storage can be unavailable in privacy modes. */ }
  }

  if (account) {
    account.dataset.currentAccess = access;
    const kicker = account.querySelector('[data-account-kicker]');
    const title = account.querySelector('[data-account-title]');
    const lede = account.querySelector('[data-account-lede]');
    const badge = account.querySelector('[data-account-access-badge]');
    if (kicker) kicker.textContent = current.kicker;
    if (title) title.textContent = current.title;
    if (lede) lede.textContent = current.lede;
    if (badge) badge.textContent = current.badge;

    account.querySelectorAll('[data-access-choice]').forEach((choice) => {
      const selected = choice.dataset.accessChoice === access;
      choice.classList.toggle('is-selected', selected);
      if (selected) choice.setAttribute('aria-current', 'page');
    });

    const alert = account.querySelector('[data-account-alert]');
    if (alert && statusCopy[status]) {
      const [heading, body] = statusCopy[status];
      alert.hidden = false;
      alert.querySelector('strong').textContent = heading;
      alert.querySelector('span').textContent = body;
      alert.dataset.state = status;
    }

    const login = account.querySelector('[data-account-login]');
    if (login) {
      const base = login.dataset.loginUrl || login.getAttribute('href');
      try {
        const url = new URL(base, window.location.origin);
        const returnPath = '/pages/my-breathmg-free';
        url.searchParams.set('return_to', returnPath);
        url.searchParams.set('return_url', returnPath);
        login.href = url.toString();
      } catch (error) { /* Keep the server-rendered fallback URL. */ }
    }

    if (account.dataset.customer === 'true') safelyStore('bmgAccessModePreviewV1', access);
  }

  if (tracker) {
    let savedAccess = 'individual';
    try { savedAccess = localStorage.getItem('bmgAccessModePreviewV1') || savedAccess; } catch (error) { /* Use fallback. */ }
    const trackerBadge = tracker.querySelector('[data-access-badge]');
    if (trackerBadge) trackerBadge.textContent = (accessCopy[savedAccess] || accessCopy.individual).badge;
  }

  document.querySelectorAll('[data-bmg-logout]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      clearBmgDeviceData();
      window.location.assign(link.href);
    });
  });

  document.querySelectorAll('[data-bmg-clear-device]').forEach((button) => {
    button.addEventListener('click', () => {
      const confirmed = window.confirm('Delete all BREATHmg practice, notes, audio position, and Circle test data saved in this browser? This cannot be undone.');
      if (!confirmed) return;
      clearBmgDeviceData();
      const statusNode = document.querySelector('[data-bmg-device-status]');
      if (statusNode) statusNode.textContent = 'This browser is cleared. Your Shopify account and orders were not deleted.';
      else window.location.reload();
    });
  });

  const deleteDialog = document.querySelector('[data-bmg-delete-dialog]');
  if (deleteDialog?.querySelector('.bmg-account-delete__success')) deleteDialog.showModal();
  document.querySelectorAll('[data-bmg-delete-open]').forEach((button) => button.addEventListener('click', () => deleteDialog?.showModal()));
  document.querySelectorAll('[data-bmg-delete-close]').forEach((button) => button.addEventListener('click', () => deleteDialog?.close()));
  deleteDialog?.addEventListener('click', (event) => {
    if (event.target === deleteDialog) deleteDialog.close();
  });

  if (invite) {
    const inviteStatus = invite.querySelector('[data-invite-status]');
    if (inviteStatus && statusCopy[status]) {
      inviteStatus.hidden = false;
      inviteStatus.querySelector('strong').textContent = statusCopy[status][0];
      inviteStatus.querySelector('span').textContent = statusCopy[status][1];
    }
    const accept = invite.querySelector('[data-buddy-preview-accept]');
    const success = invite.querySelector('[data-buddy-preview-success]');
    if (accept) accept.addEventListener('click', () => {
      safelyStore('bmgAccessModePreviewV1', 'invite');
      safelyStore('bmgBuddyInvitePreviewV1', 'accepted');
      accept.hidden = true;
      if (success) success.hidden = false;
    });
  }
})();
